module.exports = __webpack_public_path__ + "img/iconfinder_animal_beast_master_wildlife_bear_paw_druid_3938104.7ee2a239.svg";